export enum LauncherEventType {
  NetworkMessage = "NetworkMessage",
  NetworkConnected = "NetworkConnected",
  NetworkLosing = "NetworkLosing",
  NetworkDisconnected = "NetworkDisconnected",
  ChangeIsland = "ChangeIsland",
  GetUser = "GetUser",
  GetClasses = "GetClasses",
  GetLocale = "GetLocale",
  Reload = "Reload",
  GetEditorAssets = "GetEditorAssets",
}

export const iFrameLauncherEvent = "iFrameLauncherEvent" as const;

export type iFrameLauncherMessage = {
  iFrameLauncherEvent: "iFrameLauncherEvent";
  type: LauncherEventType;
  data?: string | Uint8Array;
};
